// OAuth scope for Autodesk Profile API (profapi)
// Reference: https://aps.autodesk.com/en/docs/oauth/v2/developers_guide/scopes/
// Application requires comprehensive profile access:
// - core-all: includes aboutMe, roleId, industryTaxonomyIds, companyName, ldapInfo
// - ancillary: contact info (phones, address, alternateEmail) and web links
// - img: profile image read/write
// - prefs-info: communication and newsletter preferences
// - user:read: needed for C&P and other external APIs
export const AUTH_SCOPE = 'profapi:core-all-profile:read profapi:core-all-profile:write profapi:ancillary-profile:read profapi:ancillary-profile:write profapi:img-profile:read profapi:img-profile:write profapi:prefs-info:read profapi:prefs-info:write user:read openid user:write data:read';
